<template>
  <a @click="trigger">
    <slot>
      <MButton id="configure-depreciation-btn">
        {{ $t('configure') }} {{ $tc('depreciation') }}
      </MButton>
    </slot>
    <FlotoDrawerForm
      ref="drawer"
      :open="isDrawerOpen"
      @cancel="cancelAction"
      @submit="handleSubmit"
    >
      <template v-slot:header>
        {{ $t('configure') }} {{ $tc('depreciation') }}
      </template>
      <MAlert
        v-if="
          errorMessage && formData.depreciationDerivation === 'product_level'
        "
        :closable="false"
        class="my-2"
        banner
        type="error"
      >
        <div style="white-space: pre-line;">{{ errorMessage }}</div>
      </MAlert>
      <MAlert
        v-if="
          formData.depreciationDerivation === 'product_level' &&
            formData.productName
        "
        :closable="false"
        class="my-2"
        banner
        type="info"
      >
        <div style="white-space: pre-line;"
          >{{ $tc('product') }}: {{ formData.productName }}</div
        >
      </MAlert>
      <div class="px-2">
        <MRow>
          <MCol :size="12">
            <FlotoFormItem
              id="depreciation-derivation-radio"
              :label="`${$tc('depreciation')} ${$tc('derivation')}`"
              rules="required"
            >
              <MRadioGroup
                v-model="formData.depreciationDerivation"
                :options="depreciationDerivationOptions"
              />
            </FlotoFormItem>
          </MCol>
        </MRow>
      </div>
      <DepreciationForm
        v-if="shouldDisplayForm"
        v-model="formData"
        :disabled="formData.depreciationDerivation !== 'asset_level'"
        :reset-form="resetForm"
        :module-name="moduleName"
      />
      <template v-slot:actions="{ submit, hide, processing }">
        <MButton
          v-if="shouldDisplayUpdateBtn"
          id="update-btn"
          :loading="processing"
          @click="submit"
        >
          {{ $t('update') }}
        </MButton>
        <MButton id="cancel-btn" variant="default" class="ml-2" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>
<script>
import CloneDeep from 'lodash/cloneDeep'
import {
  createDepreciationApi,
  updateDepreciationApi,
  getDepreciationByDerivationApi,
} from '@modules/asset-management/api/depreciation-api'
import { depreciationDerivationOptions } from '@modules/asset-management/helpers/depreciation'

import DepreciationForm from '@modules/asset-management/components/product-depreciation/depreciation-form'
export default {
  name: 'AssetDepreciationDrawer',
  components: { DepreciationForm },
  props: {
    resource: { type: Object, required: true },
    moduleName: { type: String, required: true },
    defaultData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    this.depreciationDerivationOptions = depreciationDerivationOptions()
    return {
      isDrawerOpen: false,
      formData: {},
      testProcessing: false,
      errorMessage: null,
    }
  },
  computed: {
    shouldDisplayUpdateBtn() {
      if (this.errorMessage) {
        return false
      }
      return true
    },
    shouldDisplayForm() {
      if (this.formData.depreciationDerivation === 'do_not_deprecate') {
        return false
      }
      if (
        this.errorMessage &&
        (this.formData.depreciationDerivation === 'do_not_deprecate' ||
          this.formData.depreciationDerivation === 'product_level')
      ) {
        return false
      }
      return true
      // return (
      //   !errorMessage || formData.depreciationDerivation !== 'do_not_deprecate'
      // )
    },
  },
  watch: {
    'formData.depreciationDerivation': {
      immediate: true,
      handler: 'getDepreciationByDerivation',
    },
  },
  methods: {
    trigger() {
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
      this.formData = CloneDeep(this.defaultData)
    },
    cancelAction() {
      this.isDrawerOpen = false
    },
    handleSubmit() {
      if (this.formData.id) {
        return updateDepreciationApi(this.formData).then(() => {
          this.isDrawerOpen = false
          this.$emit('refresh')
        })
      }
      return createDepreciationApi(this.moduleName, this.resource.id, {
        ...this.formData,
      }).then(() => {
        this.isDrawerOpen = false
        this.$emit('refresh')
      })
    },
    resetForm(data) {
      this.formData = {
        ...data,
      }
    },
    getDepreciationByDerivation(newValue, oldValue) {
      if (newValue !== oldValue) {
        getDepreciationByDerivationApi(
          this.moduleName,
          this.resource.id,
          newValue
        )
          .then((data) => {
            if (data.depreciationDerivation) {
              this.formData = data
            } else {
              this.formData = {
                depreciationDerivation: newValue,
                depreciationMethod: null,
              }
            }
            this.errorMessage = null
          })
          .catch((e) => {
            this.errorMessage = ((e.response || {}).data || {}).userMessage
            this.formData = {
              depreciationDerivation: newValue,
              depreciationMethod: null,
            }
          })
      }
    },
  },
}
</script>
